<template>
  <aha-modal
    v-if="isOpenModal"
    :no-margin-padding="true"
    :title="title"
    width="537px"
    @hide="$emit('hide')"
    class="speak-to-us-modal"
  >
    <div class="pb-5 pr-5 pl-5 speak-to-us-modal">
      <EnterpriseInquiriesForm
        :email="email"
        @hide="$emit('hide')"
        @submittedForm="afterSubmittedForm"
      >
      </EnterpriseInquiriesForm>
    </div>
  </aha-modal>
</template>
<script >
import EnterpriseInquiriesForm from '@/components-v2/my-plan/user-pricing-v3/EnterpriseInquiriesForm.vue'
// import Util from '@/util'

export default {
  components: {
    EnterpriseInquiriesForm,
  },
  props: {
    isOpenModal: {
      type: Boolean,
      default: false,
    },
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: this.$i18nPresenter.t('Speak to Us'),
    }
  },
  methods: {
    afterSubmittedForm() {
      // submit
      this.$emit('hide')
      this.$emit('showThanksModal')
    },
  },
}
</script>

  <style scoped lang="scss">
  .modal-close {
    right: 16px !important;
    top: 16px !important;
    position: absolute;
    width: 24px;
    height: 24px;
    color: #555;
    cursor: pointer;
    border: 0;

    &:hover {
      color: #348ef6;
    }
  }
  .title-speak-to-us {
    font-size: 20px;
    font-weight: bold;
    position: absolute;
    top: 20px;
  }

  </style>
